var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"crTooltip"}},[_c('a-tooltip',{attrs:{"getPopupContainer":_vm.getPopupContainer,"placement":_vm.placement,"title":"点击复制"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }